/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "../../components/header/header.ngfactory";
import * as i2 from "../../components/header/header";
import * as i3 from "ionic-angular/navigation/nav-controller";
import * as i4 from "ionic-angular/navigation/nav-params";
import * as i5 from "angularfire2/auth";
import * as i6 from "../../../globals";
import * as i7 from "../../configuration/services";
import * as i8 from "../../providers/services";
import * as i9 from "../../schools/services";
import * as i10 from "../../services/notificationsServices";
import * as i11 from "../../../../node_modules/ionic-angular/components/content/content.ngfactory";
import * as i12 from "ionic-angular/components/content/content";
import * as i13 from "ionic-angular/config/config";
import * as i14 from "ionic-angular/platform/platform";
import * as i15 from "ionic-angular/platform/dom-controller";
import * as i16 from "ionic-angular/components/app/app";
import * as i17 from "ionic-angular/platform/keyboard";
import * as i18 from "ionic-angular/navigation/view-controller";
import * as i19 from "./kitchen-delete-orders";
import * as i20 from "@ngx-translate/core";
import * as i21 from "ionic-angular/components/loading/loading-controller";
import * as i22 from "@angular/common/http";
var styles_KitchenDeleteOrdersPage = [];
var RenderType_KitchenDeleteOrdersPage = i0.ɵcrt({ encapsulation: 2, styles: styles_KitchenDeleteOrdersPage, data: {} });
export { RenderType_KitchenDeleteOrdersPage as RenderType_KitchenDeleteOrdersPage };
export function View_KitchenDeleteOrdersPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-header", [], null, null, null, i1.View_HeaderPage_0, i1.RenderType_HeaderPage)), i0.ɵdid(1, 49152, null, 0, i2.HeaderPage, [i3.NavController, i4.NavParams, i5.AngularFireAuth, i6.Globals, i7.ConfigurationServices, i8.ProvidersServices, i9.SchoolServices, i10.NotificationsServices], null, null), (_l()(), i0.ɵeld(2, 0, null, null, 1, "ion-content", [], [[2, "statusbar-padding", null], [2, "has-refresher", null]], null, null, i11.View_Content_0, i11.RenderType_Content)), i0.ɵdid(3, 4374528, null, 0, i12.Content, [i13.Config, i14.Platform, i15.DomController, i0.ElementRef, i0.Renderer, i16.App, i17.Keyboard, i0.NgZone, [2, i18.ViewController], [2, i3.NavController]], null, null)], null, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 3).statusbarPadding; var currVal_1 = i0.ɵnov(_v, 3)._hasRefresher; _ck(_v, 2, 0, currVal_0, currVal_1); }); }
export function View_KitchenDeleteOrdersPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-kitchen-delete-orders", [], null, null, null, View_KitchenDeleteOrdersPage_0, RenderType_KitchenDeleteOrdersPage)), i0.ɵdid(1, 49152, null, 0, i19.KitchenDeleteOrdersPage, [i3.NavController, i4.NavParams, i6.Globals, i20.TranslateService, i21.LoadingController, i22.HttpClient], null, null)], null, null); }
var KitchenDeleteOrdersPageNgFactory = i0.ɵccf("page-kitchen-delete-orders", i19.KitchenDeleteOrdersPage, View_KitchenDeleteOrdersPage_Host_0, {}, {}, []);
export { KitchenDeleteOrdersPageNgFactory as KitchenDeleteOrdersPageNgFactory };
//# sourceMappingURL=kitchen-delete-orders.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/kitchen/kitchen-delete-orders/kitchen-delete-orders.ngfactory.js
// module id = null
// module chunks = 